import { Box, Typography } from '@mui/material'
import { Helmet } from 'react-helmet-async'

import AppStoreBlock from '~/components/AppStore/AppStoreBlock'

const SignUpView: React.FC = () => {
  return <>
    <Helmet>
      <title>Signups Closed | Recycle at Boots</title>
    </Helmet>
    <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>Website Closed For New Signups</Typography>
    <Typography variant='body1' gutterBottom>We are no longer accepting new sign-ups to the Recycle at Boots Website</Typography>

    <Typography variant='body1'>Please register via our app here:</Typography>

    <Box sx={{ mt: 2 }}>
      <AppStoreBlock />
    </Box>

  </>
}

export default SignUpView
